import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { APIResponse, Status } from "@api/models/api-response.model";
import { LightReachModel, toLightReach } from "@api/models/finance.model";
import { Observable, of } from "rxjs";
import { catchError,map } from "rxjs/operators";
import { AuthService } from "src/app/helpers/auth.service";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class LiveAPIService {
    constructor(
        private http: HttpClient,
        private authService: AuthService,
    ) { }

    getAllLiveAPIs() {
        const account_id = this.authService.getItem('account_id');
        const emailId = this.authService.getItem('email_id');
        return this.http.get(`${environment.devIntegrationUrl}/live-api/providers?accountId=${account_id}&emailId=${emailId}`);
    }

    updateLiveAPI(payload: any) {
        return this.http.post(`${environment.devIntegrationUrl}/live-api/config`, payload);
    }

    getLiveAPIDetailsByBankname(liveAPIBankName: string) {
        const payload = {
            email: this.authService.getItem('email_id'),
            accountID: this.authService.getItem('account_id'),
            crn: this.authService.getItem('crn'),
            qrn: this.authService.getItem('qrn'),
            finance_provider_id: liveAPIBankName
        }

        return this.http.post(`${environment.devIntegrationUrl}/finance/estimated-pricing`, payload);
    }

    getLightReachData(params: any): Observable<APIResponse<LightReachModel[]>> {
        const url = `${environment.devIntegrationUrl}/finance/approved-vendors`;
        const queryString = `?accountID=${params.account_id}&email=${params.email_id}&type=${params.type}`;

        return this.http.get(`${url}${queryString}`).pipe(
            map(toLightReach),
            catchError((error) =>
                of({
                    data: [],
                    status: Status.Error,
                    error: error?.error?.msg,
                } as APIResponse<LightReachModel[]>)
            )
        );
    }
    
}